<template>
  <div class="content">
    <div class="banner-box">
      <div class="nav-box">
        <span class="arrow-left-span" @click="onClickLeft"><van-icon style="margin-left: 0.66667vw;" name="arrow-left" /></span>
        <!--        <div class="nav-title">{{goodInfo.name}}</div>-->
      </div>
      <van-swipe :height="300" class="van-swipe-box" @change="onChange">
        <van-swipe-item v-if="goodInfo && goodInfo.item_url.vedio != null">
          <div class="video-swipe-box">
            <div class="vide-swipe-video">
              <video id="video"
                     ref="myVideo"
                     :src="videoUrl" preload="auto" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"
                     x5-video-player-fullscreen="true" x5-video-orientation
                     class="video-boxs" loop autoplay disablePictureInPicture="true" controlslist="nodownload noremoteplayback"
                     controls :poster="goodInfo.image"
              ></video>
            </div>
            <!--           <div v-if="goodInfo.item_url.vedio != null" @click="playVideBox" style="display: inline-block;">-->
            <!--             <img class="vr-icon zt-icon" src="../../assets/zt_icon.png" />-->
            <!--           </div>-->
          </div>
        </van-swipe-item>
        <van-swipe-item v-for="(image, index) in banner" :key="index">
          <img class="banner-img-sw" :src="image.image" />
        </van-swipe-item>

        <template #indicator>
          <div class="custom-indicator swipeIndexBox" v-if="goodInfo && goodInfo.item_url.vedio != null" style="text-align: center">{{ swipeIndex + 1 }}/{{banner.length+1}}</div>
          <div class="custom-indicator swipeIndexBox" v-else style="text-align: center">{{ swipeIndex + 1 }}/{{banner.length}}</div>
        </template>
      </van-swipe>
      <div class="goods-detail-img-icon" v-if="goodInfo&&goodInfo.item_url != null && swipeIndex != 0">
        <div class="inner" style="text-align: center;">
          <a v-if="goodInfo.item_url.vr != null" :href="goodInfo.item_url.vr">
            <img class="vr-icon" :style="{'margin-left': (goodInfo.item_url.vedio == 'null' ?'undefined':'4vw')}" :src="require('../../assets/'+appTheme+'/vr_icon.png')" />
          </a>

        </div>
      </div>
    </div>
    <div class="good-info">
      <div class="justify-align">
        <div class="price-txt left-justifying">
          ￥<div v-if="onepay_item_id != undefined && goodInfo.onepay_goods && goodInfo.onepay_goods.useful_stock!= 0 ">{{goodInfo.onepay_goods.price}} </div>
          <div v-else>{{goodInfo.price}}</div>
          <span>原价￥{{goodInfo.market_price}}</span>
        </div>
        <div class="collect-box left-justifying">
          <img @click="shareClick" style="width: 4.66667vw;height: auto;display: inline-block;margin-right: 4vw;" :src="require('../../assets/'+appTheme+'/share_des.png')" alt="" />
          <img v-if="goodInfo.is_collect==0" @click="clickCollect(1)" src="../../assets/collect.png" alt="" />
          <img v-else @click="clickCollect(2)" src="../../assets/collect_active.png" alt="" />
          <!--          <div class="get-a-coupon" @click="clickCouponList" v-if="couponList.length>0">-->
          <!--            领券<van-icon name="arrow" />-->
          <!--          </div>-->
        </div>
      </div>
      <p class="good-title">{{goodInfo.name}}</p>
    </div>
    <div class="goods-detail" v-if="goodInfo.item_url != null">
      <div class="goods-detail-row-title">商家全球网点</div>
      <div class="goods-detail-row-body">
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_amazon">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_amazon==null" :src="require('../../assets/'+appTheme+'/yamaxun.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/yamaxun1.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_ebay">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_ebay==null" :src="require('../../assets/'+appTheme+'/ebay.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/ebay1.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_red">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_red==null" :src="require('../../assets/'+appTheme+'/red.png')" alt="">
            <img v-else :src="require('../../assets/'+appTheme+'/red1.png')" alt="" /></div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_jd">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_jd==null" :src="require('../../assets/'+appTheme+'/jd.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/jd1.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_tmall">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_tmall==null" :src="require('../../assets/'+appTheme+'/tianmao.png')" alt="">
            <img v-else :src="require('../../assets/'+appTheme+'/tianmao1.png')" alt=""/>
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_taobao">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_taobao==null" :src="require('../../assets/'+appTheme+'/taobao.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/taobao1.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_pinduoduo">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_pinduoduo==null" :src="require('../../assets/'+appTheme+'/pin.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/pin1.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.shop_wechat==null">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.shop_wechat==null" :src="require('../../assets/'+appTheme+'/weixin3.png')" alt=""/>
            <img v-else :src="require('../../assets/'+appTheme+'/weixin1.png')" alt="" />
          </div>
        </a>
      </div>
    </div>
    <div class="goods-detail" v-if="goodInfo.item_url != null">
      <div class="goods-detail-row-title">商家全球直播号</div>
      <div class="goods-detail-row-body">
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_bilibili">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_bilibili==null" :src="require('../../assets/'+appTheme+'/bilibili.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/bilibili1.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_tiktok">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_tiktok" :src="require('../../assets/'+appTheme+'/douyin1.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/douyin.png')" alt="">
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_kuaishou">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_kuaishou" :src="require('../../assets/'+appTheme+'/kuaishou1.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/kuaishou.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_taobao">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_taobao" :src="require('../../assets/'+appTheme+'/taobaozhibo1.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/taobaozhibo.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_pinduoduo">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_pinduoduo==null" :src="require('../../assets/'+appTheme+'/pin.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/pin1.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_xiaohongshu">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_xiaohongshu" :src="require('../../assets/'+appTheme+'/red1.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/red.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_facebook">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_facebook" :src="require('../../assets/'+appTheme+'/fb1.png')" alt=""/>
            <img v-else :src="require('../../assets/'+appTheme+'/fb.png')" alt="" />
          </div>
        </a>
        <a v-if="goodInfo&&goodInfo.item_url != null" class="shop-item" :href="goodInfo.item_url.live_youtube">
          <div class="img-icon">
            <img v-if="goodInfo.item_url.live_youtube" :src="require('../../assets/'+appTheme+'/youtube1.png')" alt="" />
            <img v-else :src="require('../../assets/'+appTheme+'/youtube.png')" alt="" />
          </div>
        </a>
      </div>
    </div>
    <div class="wrapper-goods-detail justify-align">
      <div class="lf-box left-justifying">
        <div class="goods-business-logo">
          <!--          <van-image width="60" height="60" :src="goodInfo.shop.full_logo"/>-->
          <img style="width: 16vw;height: 16vw;border: 0.53333vw solid #F5F5F5;" :src="full_logo" alt="" />
        </div>
        <div class="goods-business-content">
          <h2>{{shopName}}</h2>
          <!--          <div class="left-justifying box">-->
          <!--            <p>商品数量：2</p>-->
          <!--            <div class="goods-business-level">-->
          <!--              等级：-->
          <!--            </div>-->
          <!--          </div>-->

        </div>
      </div>
      <div class="btn-orange left-justifying" @click="goShop(goodInfo.shop_id)">进店逛逛 <van-icon name="arrow" /></div>
    </div>
    <!--    <div class="sku-select-box justify-align">-->
    <!--      <div class="sku-des">选择</div>-->
    <!--      <div class="left-justifying rt-box">-->
    <!--          <span class="sku-list">共三种规格可选</span> <van-icon name="arrow" />-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="des-title">—— 详情介绍 ——</div>
    <div class="discount-box" v-if="couponList.length>0">
      <div class="discount-box-item" v-for="(item,index) in couponList" :key="index">
        <div class="discount-box-default">
          <img class="discount-item-bg" :src="require('../../assets/'+appTheme+'/discount_bg.png')" alt="" />
          <div class="discount-box-content justify-align">
            <div class="discount-item">
              <div class="discount-num">
                {{item.discount | filterDiscount}} <span>折</span>
              </div>
            </div>
            <div class="discount-item discount-item-center" @click="clickBtn(item,index)">
              <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{item.title}}</div> </div>
              <!--                  <div class="goods-txt uni-ellipsis">店铺：{{item.shop.name}}</div>-->
              <div class="des-goods uni-ellipsis">{{item.desc}}</div>
              <div class="hint">最终解释权归该商家</div>
            </div>
            <div class="discount-item discount-item-three">
              <div class="is_use_box left-justifying" @click="clickCoupon(item)">
                <div class="ling-qu-btn">
                  领取
                </div>
              </div>
              <!--                  <div class="date">-->
              <!--                    有效期至-->
              <!--                  </div>-->
              <!--                  <span style="font-size: 2.4vw;">{{item.use_endtime}}</span>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="des-box" id="des-box">
      <div class="div-desc" v-html="goodInfo.desc"> {{goodInfo.detail}}</div>
    </div>
    <!--    <div class="btn-list justify-align">-->
    <!--      <div class="btn">一键清关</div><div class="btn" style="background: #FDD80D;color: #282828;">出口退税</div>-->
    <!--    </div>-->
    <!-- <div class="btn-list-sec justify-align">
      <div class="btn-item">
        <span>当前票</span>
        <div class="number">99</div>
        <div class="btn">投一票</div>
      </div>
      <div class="btn-item">
        <img src="../../assets/lp_icon.png" alt="">
        <div class="btn">拉票</div>
      </div>
      <div class="btn-item">
        <span>排名</span>
        <div class="number">23</div>
        <div class="btn">爆品榜单</div>
      </div>
    </div> -->

    <div class="serve-box">
      <div class="serve-title">买家说</div>
      <div class="live-chat-msgs">
        <van-list v-if="comments.length"  v-model="loading" :finished="finished" :immediate-check="immediate" :finished-text="finishedTxt" @load="moreList">
          <div class="item" style="align-items: start;" v-for="(item,index) in comments" :key="index">
            <div class="left-justifying">
              <div class="item-left">
                <img :src="item.avatar" class="img-circle" alt="" />
              </div>
              <div class="item-right">
                <div class="item-top justify-align">
                  <div class="item-name">{{item.nickname}}</div>

                  <!-- <div class="translate left-justifying">{{item.created_at}}</div> -->
                  <!-- <div class="translate left-justifying">
                    <div class="tran active">中文</div><div class="tran">EN</div><div class="tran">多国语言</div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="item-content">
              <div class="item-txt">{{item.content}}</div>
            </div>
          </div>
        </van-list>

      </div>
    </div>

    <!-- 输入框区域box -->
    <!--     <div class="input-box" ref="heightFace">-->
    <!--      &lt;!&ndash; 输入框区域 &ndash;&gt;-->
    <!--      &lt;!&ndash; 表情区域 &ndash;&gt;-->
    <!--      <div class="browBox" v-if="faceShow">-->
    <!--        <ul>-->
    <!--          <li v-for="(item,index) in faceList" :key="index" @click="getBrow(index)">{{item}}</li>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--     </div>-->
    <!-- 输入框区域  box  end -->
    <!--    <van-sku-->
    <!--      v-model="show"-->
    <!--      stepper-title="我要买"-->
    <!--      :sku="sku"-->
    <!--      :goods="goods"-->
    <!--      :goods-id="good_id"-->
    <!--      :quota="quota"-->
    <!--      :hide-stock="sku.hide_stock"-->
    <!--      show-add-cart-btn-->
    <!--      reset-stepper-on-hide-->
    <!--      :initial-sku="initialSku"-->
    <!--      @buy-clicked="onBuyClicked"-->
    <!--      @add-cart="onAddCartClicked"-->
    <!--    >-->
    <!--    </van-sku>-->
    <!--    <van-goods-action>-->
    <!--      <van-goods-action-icon :icon="homeIcon" style="width: 6.66667vw;" text="首页" />-->
    <!--      <van-goods-action-icon :icon="oneIcon" style="width: 6.66667vw;" text="1元购" />-->
    <!--      <van-goods-action-icon :icon="fqIcon" style="width: 6.66667vw;" text="分期" />-->
    <!--      <van-goods-action-button type="warning" style="color: #7D7D7D;font-size: 4.53333vw;font-weight: 500;" color="#D7D7D7" @click="onClickShopping" text="到店支付" />-->
    <!--      <van-goods-action-button type="danger" style="color: #282828;font-size: 4.53333vw;font-weight: 500;" color="#FDD80D" text="抢购" />-->
    <!--    </van-goods-action>-->

    <!--规格-模态层弹窗-->
    <div class="popup" :class="[popupType==1?'show':'none']">
      <!-- 遮罩层 -->
      <div class="mask" @click="hide"></div>
      <!--内容层-->
      <div class="layer">
        <div class="popup-content">
          <div class="top-box left-justifying">
            <img :src="goodInfo.image" alt="" />
            <div class="top-content">
              <div class="price-box"><span>￥</span>
                <span v-if="onepay_item_id != undefined &&goodInfo.onepay_goods && goodInfo.onepay_goods.useful_stock !=0">{{goodInfo.onepay_goods.price}}</span>
                <span v-else>{{goodInfo.price}}</span>
              </div>
              <div v-if="onepay_item_id != undefined && goodInfo.onepay_goods && goodInfo.onepay_goods.useful_stock !=0 ">库存：{{goodInfo.onepay_goods.useful_stock}}</div>
              <div v-else-if="goodInfo.half_count>0">库存：{{goodInfo.half_count}}</div>
              <div v-else>库存：{{goodInfo.number}}</div>
            </div>
          </div>
          <div class="sku-box">
            <!--            <div class="sku-box-sec">-->
            <!--              <template v-for="(attr_group,index) in attr_group_list">-->
            <!--                <div class="attr-group" :key="index">-->
            <!--                  <div class="attr-group-name" :key="index">{{attr_group.attr_group_name}}</div>-->
            <!--                  <div class="attr-list">-->
            <!--                    <span :key="index" @click="storeAttrClick(item.id,attr_group.k_id)" class="attr-item" :class="[item.checked?'active':'']" v-for="(item,index) in attr_group.attr_list" :data-group-id="attr_group.k_id" :data-id="item.id">{{item.name}}</span>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </template>-->
            <!--            </div>-->
            <!--  1元秒杀商品-->
            <div class="sku-number-box" v-if="onepay_item_id != undefined&&goodInfo.onepay_goods && goodInfo.onepay_goods.useful_stock !=0">
              <div class="justify-align">
                <div class="flex-grow-1">数量</div>
                <div class="flex-grow-0">
                  <div class="left-justifying number-input-box">
                    <div class="number-btn number-sub disabled" style="margin-right:0.01rem;">-</div>
                    <div class="flex-grow-0">
                      <input disabled class="flex-grow-1 number-input" min="1" style="padding:0" type="number" v-model="default_num" />
                    </div>
                    <div class="number-btn number-add disabled">+</div>
                  </div>
                </div>
              </div>
            </div>
            <!--            半价商品-->
            <div class="sku-number-box" v-else-if="goodInfo.half_count >0">
              <div class="justify-align">
                <div class="flex-grow-1">数量</div>
                <div class="flex-grow-0">
                  <div class="left-justifying number-input-box">
                    <div @click="numberSub" :class="[default_num<=1?'disabled':'']" class="number-btn number-sub" style="margin-right:0.01rem;">-</div>
                    <div class="flex-grow-0">
                      <input class="flex-grow-1 number-input" min="1" style="padding:0" type="number" v-model="default_num" />
                    </div>
                    <div @click="numberAdd" class="number-btn number-add">+</div>
                  </div>
                </div>
              </div>
            </div>
            <!--   普通商品-->
            <div class="sku-number-box" v-else>
              <div class="justify-align">
                <div class="flex-grow-1">数量</div>
                <div class="flex-grow-0">
                  <div class="left-justifying number-input-box">
                    <div @click="numberSub" :class="[default_num<=1?'disabled':'']" class="number-btn number-sub" style="margin-right:0.01rem;">-</div>
                    <div class="flex-grow-0">
                      <input class="flex-grow-1 number-input" min="1" style="padding:0" type="number" v-model="default_num" />
                    </div>
                    <div @click="numberAdd" class="number-btn number-add">+</div>
                  </div>
                </div>
              </div>
            </div>
            <!--   普通商品end-->
            <div class="btn-popup justify-align">
              <!--              <div class="btn add-cart" @click="shopPay">加入购物车</div>-->
              <!--              <div class="btn buy-now" @click="buyGoods">立即抢购</div>-->
              <div v-if="is_cart==0" style="width: 80%;margin: 0 auto 2.66667vw;border-radius: 4.66667vw;" class="btn add-cart" @click="submitAddCart"> 加入购物车</div>
              <div v-else style="width: 80%;margin: 0 auto 2.66667vw;border-radius: 4.66667vw;" class="btn buy-now" @click="buyGoods"> 立即抢购</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部导航 -->
    <div class="justify-align bar-bottom">
      <div class="flex-row justify-align">
        <div class="bar-bottom-btn">
          <div @click="goHome">
            <img :src="require('../../assets/'+appTheme+'/home_icon.png')" />
            <span>首页</span>
          </div>
        </div>
        <div class="bar-bottom-btn">
          <div @click="goCart">
            <img :src="require('../../assets/'+appTheme+'/gouwu.png')" />
            <span>购物车</span>
          </div>
        </div>
        <div class="bar-bottom-btn">
          <div @click="goServe">
            <img :src="require('../../assets/'+appTheme+'/g_kefu.png')" />
            <span>客服</span>
          </div>
        </div>
        <!--        <div class="bar-bottom-btn">-->
        <!--          <div @click="goPeiDeng">-->
        <!--            <img src="../../assets/1yuan_icon.png" />-->
        <!--            <span>1元购</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="bar-bottom-btn">-->
        <!--          <div @click="goFenqi" style="">-->
        <!--            <img src="../../assets/fenqi_icon.png" />-->
        <!--            <span>分期</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="flex-grow-1 justify-align">
        <div @click="addCart" class="btn add-cart">加入购物车</div>
        <div @click="buyNow" class="btn buy-now">抢购</div>
      </div>
    </div>
    <div class="null-box"></div>
    <!--    分享弹框-->
    <van-overlay :show="shareShow">
      <div class="wrapper" @click.stop>
        <div class="icon-box" @click="shareShowHide"><van-icon size="24" color="#fff" name="cross" /></div>
        <img v-if="posterUrl" class="poster-url" crossorigin="anonymous" :src="posterUrl" alt="" />
        <div class="imageWrapper" v-else id="imageWrapper" ref="imageTofile">
          <img class="img-goods goodsImg" :src="require('../../assets/'+appTheme+'/banner1.png')" alt="" />
          <div class="title">{{shareItem.name}}</div>
          <img ref="qrcode" class="qr-code-img" :src="qrcodeUrl" alt="" />
          <div class="hint">长按二维码保存图片</div>
        </div>


      </div>
    </van-overlay>
    <!-- 分享弹框end -->
    <div class="hidden" style="display: none;">
      <!--    width: 69.33333vw; height: 118.66667vw;-->
      <vue-canvas-poster v-if="qrcodeUrl" :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
    </div>
    <!--    加入购物成功提示-->

    <!--    优惠券领取-->
    <van-action-sheet v-model="couponShow" title="优惠券列表">
      <div class="content">
        <div class="nav-content">
          <div class="discount-box" v-if="couponList.length>0">
            <div class="discount-box-item" v-for="(item,index) in couponList" :key="index">
              <div class="discount-box-default">
                <img class="discount-item-bg" :src="require('../../assets/'+appTheme+'/discount_bg.png')" alt="" />
                <div class="discount-box-content justify-align">
                  <div class="discount-item">
                    <div class="discount-num">
                      {{item.discount | filterDiscount}} <span>折</span>
                    </div>
                  </div>
                  <div class="discount-item discount-item-center" @click="clickBtn(item,index)">
                    <div class="title left-justifying"><div class="title-txt uni-ellipsis">{{item.title}}</div> </div>
                    <!--                  <div class="goods-txt uni-ellipsis">店铺：{{item.shop.name}}</div>-->
                    <div class="des-goods uni-ellipsis">{{item.desc}}</div>
                    <div class="hint">最终解释权归该商家</div>
                  </div>
                  <div class="discount-item discount-item-three">
                    <div class="is_use_box left-justifying" @click="clickCoupon(item)">
                      <div class="ling-qu-btn">
                        领取
                      </div>
                    </div>
                    <!--                  <div class="date">-->
                    <!--                    有效期至-->
                    <!--                  </div>-->
                    <!--                  <span style="font-size: 2.4vw;">{{item.use_endtime}}</span>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="text-align: center;" v-else>暂无数据~</div>
        </div>
      </div>
    </van-action-sheet>

    <!--优惠券领取end-->

    <!--    视频播放弹框-->
    <!--    <div class="video-wrapper" v-if="videoShowBox">-->
    <!--      <div class="video-wrapper-content">-->
    <!--        <div class="close-box" @click="clickClose">-->
    <!--          <van-icon name="cross" />-->
    <!--        </div>-->
    <!--        <video id="video"-->
    <!--               ref="myVideo"-->
    <!--               :src="videoUrl" preload="auto" webkit-playsinline="true" playsinline="true" x-webkit-airplay="allow" x5-video-player-type="h5"-->
    <!--               x5-video-player-fullscreen="true" x5-video-orientation-->
    <!--               class="video-box" loop autoplay disablePictureInPicture="true" controlslist="nodownload noremoteplayback"-->
    <!--               controls-->
    <!--        ></video>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    视频播放弹框end-->

  </div>

</template>


<script>
import Vue from 'vue';
import {goodsListDes, goodsCollect, addCart, discountCouponList,getDiscountCoupon} from '@/api/goods'
// 导入JSON格式的表情库
const appData = require("@/assets/emojis.json");
import { Dialog } from 'vant';
import { Lazyload } from 'vant'
import coupon from "@/components/coupon";
Vue.use(Lazyload)
import QRCode from 'qrcode';
import { VueCanvasPoster } from 'vue-canvas-poster'
import {getWechat} from "@/api/zhibo";
const jweixin = require('jweixin-module');
export default {
  name: 'ProductDetail',
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      videoShowBox:false, // 是否显示播放器弹框
      videoUrl:'',
      isPlay:true,
      iconPlayShow:false,
      playOrPause:false,
      qrcodeUrl: '', // 二维码
      shareItem: '',
      posterUrl:'', // 海报
      shareGoodsImg: '',
      visible:false, // 加入购物车提示
      couponShow: false,
      painting:{
        width: '520px',
        height: '890px',
        background: '#ffffff',
        borderRadius: '10px'
      },
      shareShow:false, // 分享海报弹框
      popupType: 0, // 0 弹框隐藏  1 弹框显示
      default_num: 1,
      attr_group_list: [
        {
          attr_group_name: '颜色',
          k_id: '1',
          attr_list: [
            {
              id: '30349',
              name: '天蓝色',
              checked: false,
              imgUrl:
                'https://img.yzcdn.cn/upload_files/2017/02/21/FjKTOxjVgnUuPmHJRdunvYky9OHP.jpg!100x100.jpg'
            },
            {
              id: '1215',
              name: '白色',
              checked: false,
            }
          ],
          k_s: 's1',
          count: 2
        },
        {
          attr_group_name: '尺寸',
          k_id: '2',
          attr_list: [
            {
              id: '1193',
              name: '大', checked: false,
            },
            {
              id: '1194',
              name: '中', checked: false,
            }
          ],
          k_s: 's2',
          count: 2
        }
      ],
      banner:[],
      swipeIndex:0,
      textConent: "",
      faceList: [],
      faceShow: false,
      getBrowString: "",
      content: ['非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好，非常好非常好。'],
      good_id: '',
      goodInfo: '',
      comments: {},
      show: false,
      collect:0,
      quotaUsed: 0, // 已经购买过的数量
      goods: {
        // 数据结构见下方文档
        attr: [
          {
            attr_group_name: '颜色',
            k_id: '1',
            attr_list: [
              {
                id: '30349',
                name: '天蓝色', checked: false,
                imgUrl:
                  'https://img.yzcdn.cn/upload_files/2017/02/21/FjKTOxjVgnUuPmHJRdunvYky9OHP.jpg!100x100.jpg'
              },
              {
                id: '1215',
                name: '白色', checked: false,
              }
            ],
            k_s: 's1',
            count: 2
          },
          {
            attr_group_name: '尺寸',
            k_id: '2',
            attr_list: [
              {
                id: '1193',
                name: '大', checked: false,
              },
              {
                id: '1194',
                name: '中', checked: false,
              }
            ],
            k_s: 's2',
            count: 2
          }
        ],
      },
      homeIcon: require('@/assets/home_icon.png'),
      oneIcon: require('@/assets/1yuan_icon.png'),
      fqIcon: require('@/assets/fenqi_icon.png'),
      messageConfig: {
        // 数据结构见下方文档
      },
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
          {
            k: '颜色',
            k_id: '1',
            v: [
              {
                id: '30349',
                name: '天蓝色',
                imgUrl:
                  'https://img.yzcdn.cn/upload_files/2017/02/21/FjKTOxjVgnUuPmHJRdunvYky9OHP.jpg!100x100.jpg'
              },
              {
                id: '1215',
                name: '白色'
              }
            ],
            k_s: 's1',
            count: 2
          },
          {
            k: '尺寸',
            k_id: '2',
            v: [
              {
                id: '1193',
                name: '1'
              },
              {
                id: '1194',
                name: '2'
              }
            ],
            k_s: 's2',
            count: 2
          }
        ],
        // 所有 sku 的组合列表，如下是：白色1、白色2、天蓝色1、天蓝色2
        list: [
          {
            id: 2259,
            price: 120, //价格
            discount: 122,
            s1: '1215',
            s2: '1193',
            s3: '0',
            s4: '0',
            s5: '0',
            stock_num: 20, //库存
            goods_id: 946755
          },
          {
            id: 2260,
            price: 110,
            discount: 112,
            s1: '1215',
            s2: '1194',
            s3: '0',
            s4: '0',
            s5: '0',
            stock_num: 2, //库存
            goods_id: 946755
          },
          {
            id: 2257,
            price: 130,
            discount: 132,
            s1: '30349',
            s2: '1193',
            s3: '0',
            s4: '0',
            s5: '0',
            stock_num: 40, //库存
            goods_id: 946755
          },
          {
            id: 2258,
            price: 100,
            discount: 100,
            s1: '30349',
            s2: '1194',
            s3: '0',
            s4: '0',
            s5: '0',
            stock_num: 50, //库存
            goods_id: 946755
          }
        ],
        price: '5.00',
        stock_num: 227, // 商品总库存
        none_sku: false,  // 是否无规格商品
        hide_stock: false  // 是否隐藏剩余库存
      },
      goods_id: '946755',
      quota: 3, //限购数量
      quota_used: 0,  //已经购买过的数量
      goods_info: {
        title: '测试商品A',
        picture:
          'https://img.yzcdn.cn/upload_files/2017/03/16/Fs_OMbSFPa183sBwvG_94llUYiLa.jpeg?imageView2/2/w/100/h/100/q/75/format/jpg'
      },
      initialSku:{
        s1: "0001",
        s2: "1001",
        selectedNum: 3
      },
      full_logo:require('@/assets/default-thumb.png'),
      shopName: '',
      goodsInfo: '',
      payTypeId: '', // 一元购商品项目id
      isPay: '', // 1元购： 如果为0 不能支付
      onepay_item_id: '', // 一元购活动项目id
      inventory_number: 0, // 库存
      is_cart: 0, // 0:购物车 1是立即购买
      couponList: [], // 优惠券列表
      shopId: ''
    }
  },
  filters: {
    filterDiscount: function (value){
      var discount = value/10
      return discount
    }
  },
  components: {
    VueCanvasPoster
  },
  mounted() {
    window.addEventListener("pagehide", this.pageHide);

  },
  destroyed() {
    //移除事件处理程序
    window.removeEventListener("pagehide", this.pageHide);
  },
  created () {
    // console.log("url--info",this.$route.fullPath);
    var id = this.$route.query.id
    this.payTypeId = this.$route.query.type
    this.isPay = this.$route.query.isPay // 是否可以支付一元购 isPay:商品库存 用来判断是否可以购买
    this.onepay_item_id = this.$route.query.type // 一元购活动项目id
    // console.log(this.onepay_item_id)
    this.good_id=id
    this.goodsId = id
    // this.getGoodsInfo()
    // console.log('onepay_item_id',this.onepay_item_id)
    // 清掉缓存信息
    this.$store.commit("setBonusInfo",'')
    this.$store.commit("setGoodsInfo",'')

    this.getGoodInfo()
    this.getComments()
  },
  // updated() {
  //   window.scroll(0, 0);
  // },
methods: {
  mouseenterEnter(){
    this.iconPlayShow = true
  },
  mouseenterLeave(){
      this.iconPlayShow = false
  },
    playVideBox(){ // 显示播放器
      this.videoShowBox = true
      // this.$refs.myVideo.addEventListener('play',this.playVideo)
      // this.$refs.myVideo.addEventListener('pause',this.pauseVideo)
      this.iconPlayShow = false
      setTimeout(() => {
        let elevideo = document.getElementById('video')
        let that = this
        elevideo.play()
        elevideo.addEventListener('play', function () { //播放
          console.log("开始播放");
          that.iconPlayShow = false
        });
        elevideo.addEventListener('pause', function () { //暂停
          console.log("暂停");
          that.iconPlayShow = true
        });

      },500)
    },
  clickClose(){
    let video = document.getElementById('video')
    video.pause();
    this.$refs.myVideo.pause();//播放
    this.videoShowBox = false
  },
  // 开始播放
  playVideo() {
    console.log('播放')
    let video = document.getElementById('video')
    this.isPlay = false
    video.play();//播放
    this.$refs.myVideo.play();//播放
    window.onresize = function () {
      video.style.width = window.innerWidth + "px";
      video.style.height = window.innerHeight + "px";
    }
  },
  pauseVideo() { //暂停\播放
    console.log('暂停')
    this.$refs.myVideo.pause();//播放
    this.isPlay = true
  },
  onClickLeft() {
    if (window.history.length <= 1) {
      this.$router.push('/');
      return false
    } else {
      this.$router.go(-1);
    }
  },
  getShareInfo(){
    console.log('初始化微信')
// 获取设备信息并判断是否是ios
    var pageUrl = ''
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) { // ios
      // ios系统就拼接随机字符串
      pageUrl = this.$store.state.wxSignUrl
      console.log('ios')
    } else {
      console.log('安卓')
      pageUrl = location.href.split('#')[0]
    }

    var data = {
      liveUrl: pageUrl // encodeURIComponent(location.href.split('#')[0]) //  pageUrl
    }
    console.log(data)
    getWechat(data).then(res => {
      // console.log(res)
      if(res.code == 200)
      {
        var weChat = res.data
        console.log('weChat',weChat)
        jweixin.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
          appId: weChat.appId, // 必填，公众号的唯一标识
          timestamp:weChat.timestamp , // 必填，生成签名的时间戳
          nonceStr: weChat.nonceStr, // 必填，生成签名的随机串
          signature: weChat.signature,// 必填，签名
          jsApiList: ['checkJsApi','onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
          openTagList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'] // 跳转小程序时必填
        });
        jweixin.error((res) => {
          console.log('sdk加载失败--->', res)

        })
        // config 准备好了那么就开始操作了，
        jweixin.ready(() => {
          const that = this
          console.log('ready',this.goodsInfo.name)
          // wx-open-subscribe 原生绑定点击事件
          this.$nextTick(() => {
            if (that.videoUrl != null){ //  不能自动播放
              // that.playVideBox()
              let elevideo = document.getElementById('video')
              elevideo.play()
              console.log('播放')
            }
            //是否支持分享
            jweixin.checkJsApi({
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage','updateAppMessageShareData', 'updateTimelineShareData'],
              success: function (res) {
                console.log(res)
              }
            });
            let urlPath = location.href.split('#')[0]
            // alert("准备完毕，加载方法");
            //分享到朋友圈
            jweixin.updateTimelineShareData({
              title: that.goodsInfo.name,   // 分享时的标题
              link: urlPath,     // 分享时的链接 // keyi
              imgUrl: this.goodsInfo.image,   // 分享时的图标
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              }
            });
            jweixin.onMenuShareTimeline({ // 旧版本
              title: that.goodsInfo.name,   // 分享时的标题
              link: urlPath,     // 分享时的链接 // keyi
              imgUrl: this.goodsInfo.image,   // 分享时的图标
              success: function () {
                console.log("分享成功");
              },
              cancel: function () {
                console.log("取消分享");
              }
            })
            //分享给朋友
            jweixin.updateAppMessageShareData({
              title: that.goodsInfo.name,
              desc:' ',
              link: urlPath, // keyi
              imgUrl: that.goodsInfo.image,
              success: function (n) {
                console.log("分享成功", n);
              },
              complete: function (n) {
                console.log(n);
              }
            });

            // 旧版本
            jweixin.onMenuShareAppMessage({
              title: that.goodsInfo.name, // 分享标题
              desc: ' ', // 分享描述
              link: urlPath, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.goodsInfo.image, // 分享图标
              success: function (e) {
                // 用户点击了分享后执行的回调函数
                console.log('分享给朋友',e);
              }
            });


          })
        })

      } else {
        this.$toast(res.message)
      }
    })
  },
  //页面关闭或刷新时触发
  pageHide() {
    this.$store.commit("setWechatSignUrl", '');
  },
  clickCouponList(){ // 显示优惠券
      this.couponShow = true
    },
  clickCoupon(item,index){ // 领取优惠券 多个值，用逗号隔开
    // console.log('item',item)
    // console.log('index',index)
    var arr = this.couponList
    if (item.number >=1){
      var id = item.id
      getDiscountCoupon(id).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res)
          this.$toast('领取成功')
          setTimeout(() => {
            //通知父组件关闭
            console.log('调列表数据')
            this.getCouponList()
          }, 1000);

        }
        else
        {
          this.$toast.setDefaultOptions({ duration: 2000 });
          this.$toast(res.message)
        }
      })
    } else {
      this.$toast('已经领完~')
    }
  },
  getCouponList(){  // 获取商家优惠券
    discountCouponList( this.shopId).then(res => {
      if(res.code == 200)
      {
        // console.log('res',res)
        this.couponList = res.data
      }
      else
      {
        this.$toast(res.message)
      }
    })
  },
  shareShowHide(){
    this.shareItem = ''
    this.shareGoodsImg = ''
    this.qrcodeUrl = ''
    this.shareShow = false
    // console.log(this.qrcodeUrl)
    // console.log('shareItem',this.shareItem)
  },
  shareClick(){ // 生成二维码

    this.shareItem = this.goodInfo
    this.shareGoodsImg = this.goodInfo.image
    var id = this.goodInfo.id
    let baseUrl = ''
    let http = window.location.protocol+'//'
    let url = window.location.hostname // 获取当前访问（域名）
    baseUrl = http+url+`/goodDetails?id=${id}`  //'https://jpzs-zst.itos.cn/goodDetails?id=750'
    let hostUrl = window.location.protocol+'//'+document.location.hostname+document.location.pathname+document.location.search
    // console.log(baseUrl)
    let qrcodeUrl = hostUrl
    QRCode.toDataURL(qrcodeUrl, (err, qr) => {
      if (err) {
        this.$toast('生成二维码失败');
      } else {
        this.qrcodeUrl = qr;
        // console.log(this.qrcodeUrl)
        this.shareShow = true
        // this.imageUrlToBase64(goods.image)
        // this.drawCanvas();
        this.drawPoster()
      }
    });

  },
  drawPoster(){
    console.log('shareItem',this.shareGoodsImg)
    var total = this.shareItem.price * 0.95
    var price = total.toFixed(2);
    var discount = '折后优惠价：'+price
    this.painting = {
      width: '520px',
      height: '890px',
      background: '#ffffff',
      borderRadius: '10px',
      views: [
        {
          type: 'rect',
          css: {
            width: '502px',
            height: '876px',
            right: '9px',
            bottom: '6px',
            borderRadius: '10px',
            borderWidth: '8px',
            color: '#ffffff',
            borderColor: '#FDD80D',
          }
        },
        {
          type: 'image',
          url: this.shareGoodsImg,  // , // 'https://www.sunniejs.cn/static/avatar.png'
          css: {
            width: '370px',
            height: '370px',
            top: '30px',
            left: '75px'
          }
        },
        {
          type: 'text',
          text: this.shareItem.name,
          css: [
            {
              top: '430px',
              width: '400px',
              maxLines: 2,
              lineHeight: '50px',
              left: '60px',
              fontSize: '26px'
            }
          ]
        },
        {
          type: 'image',
          url: this.qrcodeUrl,
          css: {
            width: '170px',
            height: '170px',
            top: '530px',
            left: '175px'
          }
        },
        {
          type: "text",
          text: "长按二维码保存图片",
          css: {
            top: "720px",
            left: "136px",
            width: "360px",
            maxLines: 1,
            fontSize: "26px",
            color: '#E43A0D'
          }
        },
        // {
        //   type: 'rect',
        //   css: {
        //     width: '503px',
        //     height: '106px',
        //     right: '9px',
        //     bottom: '70px',
        //     color: '#feeb86',
        //
        //   }
        // },
        // {
        //   type: "text",
        //   text: "扫码购买立即享受95折",
        //   css: {
        //     bottom: "135px",
        //     left: "136px",
        //     width: "360px",
        //     maxLines:1,
        //     fontSize: "26px",
        //     color: '#E64D2A'
        //   }
        // },
        // {
        //   type: "text",
        //   text: discount, // 扫码购买立即享受95折 折后优惠价：15.2
        //   css: {
        //     bottom: "90px",
        //     left: "134px",
        //     width: "260px",
        //     maxLines:1,
        //     textAlign: 'center',
        //     fontSize: "26px",
        //     color: '#E64D2A'
        //   }
        // },
      ]
    }
  },
  //成功生成海报
  success(src) {
    this.posterUrl = src;
    // console.log(src)
  },
  fail(err) {
    // alert(err)
    console.log('fail', err)
  },
    handleScroll() {
    //获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      console.log(scrollTop)
    },
    clickVideo(v){
      console.log(v)
    },
    // 评论
    async getComments (page = 1) {
      var data = {
        source_id: this.goodsId,
        source_type: 'order_goods',
        page: page,
        number: 20
      }
      const res = await this.$Http.getCommentList(data)
      if (res.code != 200) {
        this.$toast(res.message)
        return
      }
      this.comments = res.data.data
    },

    // 获取商品数据
    getGoodInfo(){
      var that = this
      var data = {
        onepay_item_id:this.onepay_item_id
      }
      goodsListDes(this.good_id,data).then(res => {
        if(res.code == 200)
        {

          this.goodInfo = res.data
          // console.log('res',this.goodInfo)
          if (res.data.item_url != null){
            this.videoUrl = res.data.item_url.vedio

          }
          this.goodsInfo = res.data
          var arr =  res.data.images
          var obj = {
            image: res.data.image
          }
          arr.unshift(obj)

          this.banner = arr
          this.full_logo = res.data.shop.full_logo
          this.shopName = res.data.shop.name
          this.shopId = res.data.shop.id
          // console.log(arr)
          this.inventory_number = res.data.number
          this.getShareInfo()
          this.getCouponList()
        }
        else
        {
          this.$toast(res.message)
            // this.$router.push('/');
        }
      })
    },
    submitAddCart(){ // 商品加入购物车
      var data = {
        goods_id: this.goodInfo.id,
        number:this.default_num
      }
      addCart(data).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res)
          // this.$toast({message:'加入购物车成功',icon: require('../../assets/car_s.png')}); <van-icon name="passed" />
          this.$toast({
            message: `<div style="justify-content: center;align-items: center;padding: 10px 10px 0"><i class="van-icon van-icon-passed" style="font-size:46px;"></i><div style="padding-bottom: 10px;padding-top: 10px;font-size: 16px;">加入购物车成功</div></div>`,
            type: 'html'
          });

          this.popupType = 0
        }
        else
        {
          this.$toast(res.message)
        }
      })

    },
    buyGoods(){ // 提交订单
      console.log(this.payTypeId)
      if (this.payTypeId=='' ||this.payTypeId== undefined){ // 普通商品
        console.log('普通商品')
        this.$router.push({path:'/orderPay',query: {num:this.default_num,goods:this.goodInfo}})
      } else { // 一元购
        console.log('1yuan商品')
        if (this.goodInfo.onepay_goods.useful_stock != 0){ // 一元下单
          this.$router.push({path:'/orderPay',query: {num:this.default_num,goods:this.goodInfo,one:this.payTypeId}})
        } else{ // 一样能买
          this.$router.push({path:'/orderPay',query: {num:this.default_num,goods:this.goodInfo}})
        }

      }

    },
    numberSub() {
      var t = this;
      var a = t.default_num;
      if (a <= 1) return !0;
      a--, t.default_num = a;
    },
    numberAdd() {
      var t = this;
      console.log(t.goods.num)
      var default_num = parseInt(t.default_num)
      var num = '' // 多规格使用的
      if (this.onepay_item_id != undefined &&this.goodInfo.onepay_goods && this.goodInfo.onepay_goods.useful_stock!= 0 ){ // 一元库存
        num = parseInt(t.goodInfo.onepay_goods.useful_stock)
      } else { // 正常的
        num = parseInt(t.goodInfo.number)
      }
      // var num = this.goodInfo.number
      if (default_num>=num){
        Dialog.alert({
          title: "提示",
          message: "数量超过最大限购数",
        }).then(() => {
          // on close
        });
      } else {
        t.default_num =  default_num + 1
      }
    },
    storeAttrClick(t,g){ // 选择规格
      var e = this;
      var attrId = t;
      var groupId = g;
      var a = groupId;
      var r = attrId;
      var i = JSON.parse(JSON.stringify(e.attr_group_list));
      var o = e.goods.attr;
      var s = [];

      for (var r in e.attr_group_list){
          if (e.attr_group_list[r].k_id == groupId){
            for (var j in e.attr_group_list[r].attr_list){
              if (e.attr_group_list[r].attr_list[j].id == attrId){
                e.attr_group_list[r].attr_list[j].checked = true
              } else {
                e.attr_group_list[r].attr_list[j].checked = false
              }
            }
          }
      }

      console.log(t,g)
    },
    hide() {
      this.popupType =0
    },
    goFenqi(){
      this.$toast('暂未开放，敬请期待')
    },
    goPeiDeng(){
      this.$toast('暂未开放，敬请期待')
    },
    goHome(){
      this.$router.push({path:'/'})
    },
    goCart(){
      // this.$toast('暂未开放，敬请期待')
      this.$router.push({path:'/cart'})
    },
    goServe(){
      this.$router.push({path:'/service',query:{type:'goods'}})
    },
    addCart(){ // 显示加入购物车弹框
      // this.$toast('暂未开放，敬请期待')

      this.is_cart = 0 // 显示加入购物车按钮
      if (this.payTypeId=='' ||this.payTypeId== undefined){ // 普通商品
        console.log('普通商品')
        if (this.goodInfo.number != 0 && this.goodInfo.on_sale != 0){
          this.popupType =1 // 显示规格弹框
        } else {
          this.$toast('已售完')
        }
      }else { // 一元抢购 不支持加入购物车
        this.$toast('秒杀商品不支持加入购物车')
      }

    },
    buyNow(){ // 显示弹框抢购
      this.is_cart = 1 // 显示抢购按钮
      // onepay_item_id != undefined &&goodInfo.onepay_goods && goodInfo.onepay_goods.useful_stock!= 0

      // this.$router.push({path:'/orderPay',query: {id:'10387'}})

      if (this.payTypeId=='' ||this.payTypeId== undefined){ // 普通商品
        console.log('普通商品')
        if (this.goodInfo.number != 0 && this.goodInfo.on_sale != 0){
          this.popupType =1 // 显示规格弹框
        } else {
          this.$toast('已售完')
        }
      } else {
        if (this.isPay == 0){ // 库存为0 已售完
          this.$toast('已售完')
        } else {
          this.popupType =1 // 显示规格弹框
        }
      }
    },
    onChange(index) {
      this.swipeIndex = index
      if(index == 0 && this.goodInfo.item_url.vedio != null){
        let video = document.getElementById('video')
        // video.pause();
        video.play()
      } else if (index != 0 && this.goodInfo.item_url.vedio != null){
        let video = document.getElementById('video')
        video.pause();
      } else {
        // console.log('没有视频')
      }
    },
    // 表情
    faceContent() {
      this.faceShow = !this.faceShow;
      if (this.faceShow == true) {
        for (let i in appData) {
          this.faceList.push(appData[i].char);
        }
      } else {
        this.faceList = [];
      }
    },
    // 获取用户点击之后的标签 ，存放到输入框内
    getBrow(index) {
      for (let i in this.faceList) {
        if (index == i) {
          this.getBrowString = this.faceList[index];
          this.textConent += this.getBrowString;
        }
      }
    },
    // 将input的内容渲染到页面上
    referContent() {
      if (this.textConent == "") return alert("请输入内容");
      // 存入
      this.content.push(this.textConent);
      // 清空input数据
      this.textConent = "";
      // 关闭表情列表
      this.faceShow = false;
    },
    clickCollect(e){ // 是否收藏
      this.collect = e
      // console.log('是否收藏',e)
      var that = this
      goodsCollect(this.good_id,{status: e}).then(res => {
        if(res.code == 200)
        {
          // this.$toast(res.message)
          if (e==1){
            that.goodInfo.is_collect = 1 // 设置已收藏
          } else {
            that.goodInfo.is_collect = 0
          }
          // that.goodInfo.is_collect = e ==1? 1: 2
          // setTimeout(function()  {
          //   that.getGoodInfo()//娃娃消失
          // }, 1000);
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    goShop (id) {
      this.$router.push({path:'/shopDes',query: {id:id}})
    },
    onClickShopping() {
      this.show = true
    },
    onBuyClicked(sku) {
      this.$toast("buy:" + JSON.stringify(sku));
      // console.log(JSON.stringify(sku));
      this.$router.push({name:'orderSubmit',params: {id:'1'}})
    },
    onAddCartClicked(sku) {
      this.$toast("add cart:" + JSON.stringify(sku));
    },
    async getList(){
      var data = {
        id: this.good_id
      }
      let res = await this.$Http.getGoodsDes(data)
      console.log(res)
      if (res.code == 0){
        this.goodInfo = res.data
        this.goods = res.data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/table{
  width: 100%;font-size: 14px!important;
}
/deep/td{
  border: 1px solid;
}

.imageWrapper{
  width: 520px;
  height: 890px;
  background: #FFFFFF;
  border: 6px solid #FDD80D;
  border-radius: 20px;margin: 0 auto;
  .title{
    padding: 0px 50px 0;font-size: 24px;
    color: #282828;
    line-height: 34px;
  }
  #canvas{
    width: 370px;
    height: 370px;
  }
  .img-goods{
    width: 370px;
    height: 370px;
    border-radius: 10px;margin: 30px auto;display: block;
  }
  .qr-code-img{
    width: 200px;
    height: 200px;display: block;margin: 0 auto;
  }
  .hint{
    font-size: 24px;color: #E43A0D;text-align: center;
  }
}
.wrapper{
  .icon-box{
    width: 630px;text-align: right;margin: 120px auto 30px;
  }
  .poster-url{
    width: 520px;
    height: 890px;display: block;margin: 0 auto;
  }
}
.popup {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  &.show {
    display: block;
    .mask {
      animation: showPopup 0.2s linear both;
    }
    .layer {
      animation: showLayer 0.2s linear both;

    }
  }
  &.hide {
    .mask {
      animation: hidePopup 0.2s linear both;
    }
    .layer {
      animation: hideLayer 0.2s linear both;
    }
  }
  &.none {
    display: none;
  }
  .mask {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .popup-content{
    .top-box{
      padding: 24px;
      border-bottom: 1px solid #f5f5f3;
      img{
        width: 150px;height: 150px;background: #cccccc;display: inline-block;margin-right: 35px;
      }
      .top-content{
        font-size: 28px;
        .price-box{
          margin-bottom: 25px;
          font-size: 42px;color:  #ee0a24; font-weight: 500;
          span{
            font-size: 28px;
          }
        }
      }
    }
    .sku-box{
      padding: 24px;
      text-align: left;
      .sku-box-sec{
        max-height: 500px;overflow-y: auto;
      }
      .attr-group-name{
        text-align: left;
      }
      .attr-list{
        padding: 20px 0;
        .attr-item{
          display: inline-block;padding: 10px 20px;background: #f7f8fa;margin-right: 20px;color: #323233;
          border-radius: 4px;
          cursor: pointer;
        }
        .active {
          background: #ff4544;
          color: #fff;
        }
      }
    }
    .btn-popup{
      .btn{
        width: 50%;text-align: center;height: 70px; line-height: 70px;text-align: center;
      }
      .add-cart{
        border-radius: 35px 0px 0px 35px; background: #55BB3A;color: #fff;text-align: center!important;
      }
      .buy-now{
        background: #FDD80D;
        border-radius: 0px 35px 35px 0px;
        color: #282828;text-align: center;
      }
    }
  }
  .sku-number-box{
    padding: 24px 0;border-top: 1px solid #f5f5f3;
    .number-input-box{
      .number-btn{
        color: #323233;
        background-color: #f2f3f5;width: 70px;
        height: 70px;line-height: 70px;text-align: center;font-size: 45px;
      }
      .number-input{
        width: 100px;height: 70px;line-height: 70px;text-align: center;border: none;background-color: #f2f3f5;margin: 0 4px;
      }
      .disabled {
        background: #f6f6f6;
        color: #aaa;
      }
    }
  }
  .layer {
    position: fixed;
    z-index: 99;
    bottom: 0;
    width: 100%;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
  }
  .service {
    min-height: 600px;
    .row {
      margin: 30px;
      .title {
        font-size: 30px;
        margin: 10px 0;
      }
      .description {
        font-size: 28px;
        color: #999;
      }
    }
  }
  @keyframes showPopup {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes hidePopup {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  @keyframes showLayer {
    0% {
      transform: translateY(120%);
    }
    100% {
      transform: translateY(0%);
    }
  }
  @keyframes hideLayer {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(120%);
    }
  }
}
.bar-bottom{
  width: 100%;
  position: fixed;left: 0;bottom: 0;z-index: 5;
  background: #FFFFFF;
  .flex-row{
    width: 210px;padding: 20px 10px 20px 30px;
    .bar-bottom-btn{
      text-align: center;
      img{
        display: block;width: 50px;height: auto;margin: 0 auto;
      }
    }
  }
  .flex-grow-1{
    width:450px;padding: 20px 30px 20px 0;
    .btn{
      width: 50%;padding: 12px 0;
      //width: 190px;
      font-size: 34px;font-weight: 500;text-align: center;
    }
    .add-cart{
      border-radius: 35px 0px 0px 35px;background: #55BB3A;color: #fff;text-align: center;
    }
    .buy-now{
      background: #FDD80D;
      border-radius: 0px 35px 35px 0px;
      color: #282828;
    }
  }
}
::v-deep .van-sku-group-container {
  text-align: left;
}
.sku-select-box{
  padding: 24px 24px;background: #fff;margin-bottom: 20px;
  .rt-box{
    color: #999;
    .sku-list{
      font-size: 24px;display: inline-block;margin-right: 20px;
    }
  }
}
.banner-box{
  position: relative;
  .nav-box{
    position: absolute;width: 100%;z-index: 1;left: 0;top: 0;
    padding: 20px 0;
    .arrow-left-span{
      position: absolute;left: 20px;font-size: 45px;top: 20px;
      width: 60px;line-height: 65px;height: 60px;display: block;
      background: rgba(0,0,0,0.4);color: #fff;border-radius: 100px;
    }
    .nav-title{
      width: 50%;overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;margin: 0 auto;
    }
  }
  .van-swipe-box{

    width: 750px;height: 750px;
    .van-swipe-item{
      height: 750px;
      img{
        height: 750px; width: 750px;
      }
    }
  }
  .swipeIndexBox{
    position: absolute;right: 30px;bottom: 20px;
    width: 72px;
    height: 44px;line-height: 44px;
    background: rgba(8, 8, 8, 0.5);
    border-radius: 22px;font-size: 22px;color: #FFFFFF;
  }
  .goods-detail-img-icon{
    position: absolute;
    margin: auto;width: 100%;
    left: 0;top: 309px;
    .vr-icon{
      width: 136px;height: auto;margin-left: 83px;display: inline-block;
    }
  }
  .video-swipe-box{
    position: relative;
    height: 750px; width: 750px;
    .vide-swipe-video{
      height: 750px; width: 750px;
    }
    .vr-icon{
      width: 136px;height: 136px;position: absolute;z-index: 1;top:40%;left: 50%;margin-left: -68px;
    }
    .video-boxs{
      height: 750px;
      width: 100%;position: relative;
      #myVideo{
        height: 750px;width: 100%;position: absolute;left: 0;top: 0;
        padding-top: 156.962963%;
      }
    }
  }
}


.des-box{
  margin-bottom:20px;background:#fff;
  ::v-deep img {
    width: 100% !important;
    height: auto;display: block;
  }
  .div-desc{
    padding: 20px;font-size: 28px;
    overflow: hidden;
    img{
      max-width: 100% !important;
      height: auto;display: block;
    }
  }
}
.des-title{
  font-size: 26px;
  line-height: 48px;
  height: 48px;color: #B2B2B2;text-align: center;
}
.good-info{
  background: #fff;
  margin-bottom: 20px;
  padding: 20px;
  .good-title{
    font-size: 30px;
    text-align: left;
    font-weight: 500;
    color: #2F2F2F;
  }
  .price-txt{
    font-size: 38px;text-align: left;font-weight: 500;
    color: #DF212D;
    div{
      font-size: 58px;margin-right: 20px;
    }
    span{
      color: #A6A6A6;font-size: 28px;text-decoration:line-through;
    }
  }
  .sale-txt{
    font-size: 24px;color: #999;display: inline-block;margin-left: 20px;
  }
  .collect-box{
    img{
      width: 48px;height: auto;display: block;
    }
  }
}
.goods-detail{
  border-left: 0;
  border-right: 0;
  padding: 10px;background: #ffffff;
  .goods-detail-row-title {
    font-weight: 500;
    color: #A6A6A6;
    padding: 15px;
    text-align: left;
  }
  .goods-detail-row-body{
    margin: 0;
    .shop-item{
      display: inline-block;
      width: 12.5%;
      text-align: center;
      .img-icon{
        width: 75px;
        height: 75px;margin: 0 auto;
        img{
          width: 100%;display: block;height: auto;
        }
      }
    }
  }
}
.wrapper-goods-detail{
  padding: 20px;background: #fff;margin-bottom: 10px;margin-top: 20px;
  .goods-business-content{
    margin-left: 15px;
  }
  h2{
    font-size: 30px;text-align: left;margin-bottom: 0;margin-top: 0;
  }

  .box{
    color: #B2B2B2;font-size: 24px;
    p{
      margin: 10px 0;text-align: left;
    }
    .goods-business-level{
      font-size: 24px;text-align: left; margin-left: 10px;
    }
  }

  .btn-orange{
    font-size: 28px;font-weight: 500;
    color: #B2B2B2;
  }
}
.null-box{
  height: 120px;
}
.btn-list{
  padding: 29px;background: #ffffff;margin-top: 51px;margin-bottom: 25px;text-align: center;
  .btn{
    width: 330px;
    font-size: 34px;
    background: #55BB3A; padding: 20px 0;
    border-radius: 43px;
    color: #F5F5F5;
  }
}
.btn-list-sec{
  padding: 20px 29px 29px;
  background: #ffffff;
  .btn-item{
    color: #282828;font-weight: bold;
font-size: 28px;
    .number{
      color: #55BB3A;margin: 20px auto;
    }
    img{
      width: 71px;height: auto;display: block;margin: 0 auto 39px;
    }
  }
  .btn{
    width: 190px;
    padding: 12px 0;
    background: #FDD80D;
    border-radius: 32px;font-weight: bold;
    color: #282828;font-size: 28px;
  }
}
.serve-box{
  color: #282828;background: #fff;
  .serve-title{
    font-size: 32px;padding-left: 25px;text-align: left;font-weight: bold;
    color: #282828;padding-top: 30px;padding-bottom: 20px;
  }
}
.live-chat-msgs{
  background: #fff;padding: 0 20px 90px;
  .item{
    padding: 15px 0;font-size: 26px;
    border-bottom: 1px solid #e8e8e8;
    .item-content{
      .item-txt{
        padding: 5px 30px;text-align: left;font-size: 26px;
      }

    }
    .item-left{
      width: 12%;
      img {
        width: 80px;background: #cccccc;border-radius: 80px;height: 80px;
      }
    }
    .item-right{
      width: 80%;margin-left: 15px;
      .item-top{
        padding-bottom: 10px;
      }
      .translate{
        div{
          margin-right: 10px;color: #EDA10E;
          background: #FFFFFF;
          border: 2px solid #EDA10E;
          border-radius: 5px;padding: 5px 10px;
        }
        .active{
          background: #EDA10E;color:#ffffff;
        }
      }

    }
  }
}
.input-box{
  //position: fixed;
  //width: 100%;left: 0; bottom: 120px;
  background: #D0E1CB;
  .send-btn{
    width: 120px;
    color: #FFFFFF;
    background: #55BB3A;padding: 12px 0;
    border-radius: 32px;margin-left:26px;
  }
  .input-content{
    padding: 20px 20px;
    input{
      //width: 80%;margin: 0 15px;height: 60px;line-height: 60px;padding: 0 5px;
      width: 530px;
      height: 66px;line-height: 66px;
      background: #FFFFFF;padding: 0 10px;
      border-radius: 33px;border: none;
    }
  }
  .browBox {
    width: 100%;
    height: 200px;
    background: #e6e6e6;
    //position: absolute;
    //bottom: 0px;
    overflow: scroll;
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 10px;
      li {
        width: 14%;
        margin: 5px 0;
        font-size: 42px;
        list-style: none;
        text-align: center;
      }
    }
  }
}
.get-a-coupon{
  background: #fd4444;color: #FFFFFF;padding: 5px 2px 5px 25px;border-bottom-left-radius: 30px;
  border-top-left-radius: 30px;margin-left: 20px;margin-right: -20px;font-size: 26px;
  cursor: pointer;
}

.discount-box{
  //padding-bottom:50px;
  padding: 0 24px 30px;
  .discount-box-item{
    width: 100%;margin: 25px auto 0;
    .discount-box-default{
      position: relative;

    }
    .discount-item-bg{
      width: 100%;height: auto;display: block;
    }
    .discount-box-content{
      position: absolute;z-index: 1;
      left: 30px;
      top: 50px;
      .discount-num{
        font-weight: bold;font-size: 50px;width: 130px;text-align: center;margin-right: 40px;
        color: #FF953A;
        span{

          font-size: 22px;
        }
      }
      .title{
        .title-txt{
          font-size: 28px;
          font-weight: bold;
          color: #E9400B;width: 75%;
          overflow: hidden;
        }
        img{
          width: 12px;display: inline-block;height: auto;margin-left: 20px;
        }
      }
      .discount-item-center{
        padding: 0 20px;font-size: 22px;width: 270px;text-align: left;color: #9E9E9E;
        .goods-txt{
          display: inline-block;
          background: #FFF0E5;
          border-radius: 19px;font-weight: 400;
          color: #FB6666;font-size: 22px;padding: 5px 10px;margin: 20px auto;width:80%;
          overflow: hidden;
        }
        .des-goods{
          width: 90%;margin-bottom: 10px;font-size: 26px;margin-top: 20px;
          overflow: hidden;
        }
      }
      .discount-item-three{
        color: #FFFFFF;margin-left: 25px;
        .date{
          margin-top: 22px;margin-bottom: 5px;
        }
      }
      .is_use_box{
        font-size: 36px;color: #FFFFFF;
        .ling-qu-btn{
          font-size: 26px;text-align: center;
          background: #FFFFFF;
          border-radius: 34px;color: #282828;padding: 15px 40px;
        }
      }
    }
  }
}
.video-wrapper{
  position: fixed;left:0;top: 0;
  width: 100%;height: 100%;background: #282828;z-index: 999;
  .video-wrapper-content{
    position: relative;
    width: 100%;height: 100vh;
    .video-box{
      width: 100%;height: 100%;position: absolute;left: 0;top: 0;
      //object-fit: cover;
    }
  }
  .lp-player-btn{
    position: absolute;
    width: 100%;
    height: 90vh;
    z-index: 999;
    top: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 50px;
    color: #fff;
    //background: rgba(0,0,0,.3);top: 0;
  }
  .close-box{
    position: absolute;right:45px;top: 70px;z-index: 3;font-size: 55px;color: #ffffff;font-weight: bold;
    width: 80px;height: 80px;background: rgba(0, 0, 0, 0.4);text-align: center;line-height: 80px;
  }
}
.edui-upload-video{
  width: 100% !important;
  background: #666666;
}
.des-box ::v-deep video{
  width: 100% !important;
}
</style>
